import { Spinner } from '@mi-front/ui';
import TextSnippetIcon from '@mui/icons-material/TextSnippet';
import { Alert, Box, Checkbox, Button } from '@mui/material';
import AlertTitle from '@mui/material/AlertTitle';
import { FormattedMessage } from 'react-intl';
import { Fragment } from '../../../../../types';

interface Props {
  fragment: Fragment;
  onDownloadClick: (format: string) => void;
  format: string;
  isPending: boolean;
  speakerIdCheck: boolean;
  onSpeakerIdChange: (value: boolean) => void;
}

export function SubtitlesStatusView(p: Props) {
  const { fragment, onDownloadClick, format, isPending, speakerIdCheck, onSpeakerIdChange } = p;
  const { media } = fragment;

  return (
    <div>
      {(media.status === 'WAITING' || media.status === 'IN_PROGRESS') && (
        <Alert severity="info">
          <AlertTitle>
            <FormattedMessage
              id="fragments.subtitlesStatus.waiting"
              defaultMessage="Subtitles generation in progress"
            />
          </AlertTitle>
          <div>
            <Spinner />
          </div>
        </Alert>
      )}

      {media.status === 'ERROR' && (
        <Alert severity="error">
          <AlertTitle>
            <FormattedMessage
              id="fragments.subtitlesStatus.error"
              defaultMessage="An error occurred during the generation of the subtitles, contact support."
            />
          </AlertTitle>
        </Alert>
      )}

      {media.status === 'READY' && (
        <Alert severity="success">
          <AlertTitle>
            <FormattedMessage
              id="fragments.subtitlesStatus.ready"
              defaultMessage="Los subtítulos del fragmento se generaron correctamente"
            />
          </AlertTitle>
          <Box mt={2} display="flex" alignItems="center" gap={2}>
            <Button
              color="inherit"
              variant="outlined"
              size="small"
              loading={format === 'txt' && isPending}
              onClick={() => onDownloadClick('txt')}
              startIcon={<TextSnippetIcon />}
            >
              <FormattedMessage
                id="fragments.subtitlesStatus.download"
                defaultMessage="Descargar subtítulos"
              />{' '}
              <FormattedMessage id="fragments.subtitlesStatus.formatTxt" defaultMessage=".TXT" />
            </Button>
            <Button
              color="inherit"
              variant="outlined"
              size="small"
              loading={format === 'srt' && isPending}
              onClick={() => onDownloadClick('srt')}
              startIcon={<TextSnippetIcon />}
            >
              <FormattedMessage
                id="fragments.subtitlesStatus.download"
                defaultMessage="Descargar subtítulos"
              />{' '}
              <FormattedMessage id="fragments.subtitlesStatus.formatSrt" defaultMessage=".SRT" />
            </Button>
            {/* <Button
              color="inherit"
              variant="outlined"
              size="small"
              loading={format === 'csv' && isPending}
              onClick={() => onDownloadClick('csv')}
              startIcon={<TextSnippetIcon />}
            >
              <FormattedMessage
                id="fragments.subtitlesStatus.download"
                defaultMessage="Descargar subtítulos"
              />{' '}
              .CSV
            </Button> */}
            <Button
              color="inherit"
              variant="outlined"
              size="small"
              loading={format === 'json' && isPending}
              onClick={() => onDownloadClick('json')}
              startIcon={<TextSnippetIcon />}
            >
              <FormattedMessage
                id="fragments.subtitlesStatus.download"
                defaultMessage="Descargar subtítulos"
              />{' '}
              <FormattedMessage id="fragments.subtitlesStatus.formatJson" defaultMessage=".JSON" />
            </Button>
            <div>
              <Checkbox
                checked={speakerIdCheck}
                onChange={(event) => {
                  onSpeakerIdChange(event.target.checked);
                }}
              />
              <FormattedMessage
                id="fragments.subtitlesStatus.add"
                defaultMessage="Agregar ID de hablante"
              />
            </div>
          </Box>
        </Alert>
      )}
    </div>
  );
}
